/* (ignored) */


//////////////////
// WEBPACK FOOTER
// buffer (ignored)
// module id = 1190
// module chunks = 0